import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SpinnerBlock from 'components/others/SpinnerBlock';
import ObjectStatusHistoryTableBody from './ObjectStatusHistoryTableBody';
import type { ObjectStatusHistoryRow } from '../model';

interface ObjectStatusHistoryTableProps {
    rows: ObjectStatusHistoryRow[];
    loading: boolean;
}

const ObjectStatusHistoryTable = ({ rows, loading }: ObjectStatusHistoryTableProps) => {
    const { t } = useTranslation(['Objects']);

    return (
        <div className="position-relative">
            <SpinnerBlock onlyBlur={true} show={loading} />
            <div className="crm-table-wrap object-status-history-table-wrap">
                <Table className="ObjectStatusHistoryTable table-hover mb-0">
                    <thead>
                        <tr className="bg-light">
                            <td className="head-event">{t('fields.status')}</td>
                            <td className="head-date">{t('objectClose.cols.date')}</td>
                            <td className="head-username">{t('objectClose.cols.user')}</td>
                            <td className="head-comment">{t('objectClose.cols.reason')}</td>
                        </tr>
                    </thead>
                    <ObjectStatusHistoryTableBody rows={rows} loading={loading} />
                </Table>
            </div>
        </div>
    );
};

export default ObjectStatusHistoryTable;
